import React, { Component } from 'react';
import { string, bool, object, array, func, number, node } from 'prop-types';
import Parser from 'html-react-parser';
import MathJax from 'react-mathjax';
import { themr } from 'react-css-themr';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { getIsInapp } from '@blueberry/redux/location';
import {
  getRelatedPosts,
  getCurrentQuizIndex,
  getConcepts,
} from '@blueberry/redux/post';
import { getUserID } from '@blueberry/redux/profile';

import PostList from '@blueberry/components/PostList';
import CTAFooter from '@blueberry/components/CTAFooter';
import AuthorBlock from '../AuthorBlock';
import AuthorDetail from './components/AuthorDetail';
import TagBlock from './components/TagBlock';
import QuizBlock from './components/QuizBlock';
import SocialMedia from './components/SocialMedia';

import styles from './ContentBlock.scss';

const LATEX_TAG_NAME = 'latex';
const LATEX_TAG = `<${LATEX_TAG_NAME}>`;

// We need to disable the line below
// as es6 rule require a uniform return
// however the plugin prefers a return
// only when replacement is needed.
const parserOptions = {
  replace: domNode => {
    // eslint-disable-line
    if (
      domNode.name === LATEX_TAG_NAME &&
      domNode.children &&
      domNode.children.length
    ) {
      return <MathJax.Node formula={domNode.children[0].data} inline />;
    }
  },
};

const mapStateToProps = state => ({
  relatedPosts: getRelatedPosts(state),
  userId: getUserID(state),
  isInApp: getIsInapp(state),
  currentQuizIndex: getCurrentQuizIndex(state),
  concepts: getConcepts(state),
});

class ContentBlock extends Component {
  static propTypes = {
    currentQuizIndex: number.isRequired,
    description: string.isRequired,
    isInApp: bool.isRequired,
    relatedPosts: array.isRequired,
    t: func.isRequired,
    theme: object.isRequired,
    authorName: string,
    breadcrumb: node,
    concepts: array,
    publishDate: string,
    showAuthorBlock: bool,
    title: string,
    userId: string,
  };

  static defaultProps = {
    concepts: [],
    title: '',
    userId: '',
    breadcrumb: undefined,
  };

  state = {
    isLatex: this.props.description.indexOf(LATEX_TAG) > -1,
  };

  renderLatexDescription = description => (
    <div className={this.props.theme.content}>
      <MathJax.Provider>{Parser(description, parserOptions)}</MathJax.Provider>
    </div>
  );

  renderDescription = description => (
    <div
      className={this.props.theme.content}
      dangerouslySetInnerHTML={{
        __html: description,
      }}
    />
  );

  renderContentBlock() {
    const {
      title,
      description,
      theme,
      authorName,
      showAuthorBlock,
      publishDate,
      breadcrumb,
      isInApp,
      currentQuizIndex,
    } = this.props;
    const { isLatex } = this.state;

    return (
      <React.Fragment>
        <div className={theme.contentBlock}>
          {!isInApp && breadcrumb}
          {title && <h1 className={theme.title}>{title}</h1>}

          {!!showAuthorBlock && (
            <AuthorBlock authorName={authorName} publishDate={publishDate} />
          )}

          {isLatex
            ? this.renderLatexDescription(description)
            : this.renderDescription(description)}

          {!isInApp && (
            <div className={theme.tagBlock}>
              <TagBlock />
            </div>
          )}
        </div>

        {currentQuizIndex > -1 && <QuizBlock />}

        <div className={theme.contentBlock}>
          {!isInApp && <SocialMedia />}
          <AuthorDetail />
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { theme, relatedPosts, t, isInApp, userId } = this.props;
    const hasRelatedPosts = relatedPosts.length > 0;
    const showCtaFooter = !userId && !isInApp;

    return (
      <div className={theme.root}>
        <div className={theme.contentBlockRoot}>
          {this.renderContentBlock()}
        </div>

        {hasRelatedPosts && (
          <div className={theme.postList}>
            <PostList posts={relatedPosts} title={t('channel.related')} />
          </div>
        )}

        {showCtaFooter && (
          <CTAFooter
            title={t('post:post.ctaFooter.title')}
            subTitle={t('post:post.ctaFooter.subTitle')}
            buttonText={t('post:post.ctaFooter.btnText')}
          />
        )}
      </div>
    );
  }
}

export default compose(
  connect(mapStateToProps),
  translate(['channel', 'post']),
  themr('DefaultContentBlockTheme', styles, { composeTheme: false })
)(ContentBlock);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/ContentBlock.jsx